import { useEffect, useState } from 'react'

const STORAGE_KEY = 'labs-vv-debug'

/** DEV only: set `localStorage.labs-vv-debug = '1'` or open with `?vvdebug=1` once to enable. */
export function LabsViewportDebug() {
  const [enabled, setEnabled] = useState(false)
  const [snapshot, setSnapshot] = useState({
    innerH: 0,
    vvH: 0,
    offsetTop: 0,
    offsetLeft: 0,
    scrollX: 0,
    scrollY: 0,
  })

  useEffect(() => {
    if (!import.meta.env.DEV) return
    const params = new URLSearchParams(window.location.search)
    if (params.get('vvdebug') === '1') {
      try {
        localStorage.setItem(STORAGE_KEY, '1')
      } catch {
        /* ignore */
      }
    }
    try {
      setEnabled(localStorage.getItem(STORAGE_KEY) === '1')
    } catch {
      setEnabled(false)
    }
  }, [])

  useEffect(() => {
    if (!import.meta.env.DEV || !enabled) return

    const read = () => {
      const vv = window.visualViewport
      setSnapshot({
        innerH: window.innerHeight,
        vvH: vv ? Math.round(vv.height) : window.innerHeight,
        offsetTop: vv ? Math.round(vv.offsetTop) : 0,
        offsetLeft: vv ? Math.round(vv.offsetLeft) : 0,
        scrollX: Math.round(window.scrollX),
        scrollY: Math.round(window.scrollY),
      })
    }

    let raf = 0
    const schedule = () => {
      if (raf) cancelAnimationFrame(raf)
      raf = requestAnimationFrame(() => {
        raf = 0
        read()
      })
    }

    read()
    const vv = window.visualViewport
    vv?.addEventListener('resize', schedule)
    vv?.addEventListener('scroll', schedule)
    window.addEventListener('resize', schedule)
    window.addEventListener('scroll', schedule, { passive: true })

    return () => {
      if (raf) cancelAnimationFrame(raf)
      vv?.removeEventListener('resize', schedule)
      vv?.removeEventListener('scroll', schedule)
      window.removeEventListener('resize', schedule)
      window.removeEventListener('scroll', schedule)
    }
  }, [enabled])

  if (!import.meta.env.DEV || !enabled) return null

  return (
    <div
      className="pointer-events-none fixed bottom-2 right-2 z-[9999] max-w-[min(100vw-1rem,14rem)] rounded border border-border bg-popover px-2 py-1 font-mono text-xs leading-tight text-popover-foreground shadow-md"
      aria-hidden
    >
      <div>innerH {snapshot.innerH}</div>
      <div>vv.h {snapshot.vvH}</div>
      <div>vv.ot {snapshot.offsetTop}</div>
      <div>vv.ol {snapshot.offsetLeft}</div>
      <div>scrollX {snapshot.scrollX}</div>
      <div>scrollY {snapshot.scrollY}</div>
    </div>
  )
}
